import { Injectable, ClassProvider } from '@angular/core';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
class AppHammerConfig extends HammerGestureConfig {
  overrides = <any>{
    pinch: { enable: false },
    rotate: { enable: false },
    swipe: {
      direction: Hammer.DIRECTION_HORIZONTAL
    },
    pan: {
      direction: Hammer.DIRECTION_HORIZONTAL
    }
  }
}

export const appHammerConfigProvider = <ClassProvider>{
  provide: HAMMER_GESTURE_CONFIG,
  useClass: AppHammerConfig
}
